function intPhoneNumber(visitor_country,input) {
	intlTelInput(input, {
	  initialCountry: visitor_country,
	  autoPlaceholder: "off",
	  separateDialCode: true,
	  customContainer: "w-100",
	  preferredCountries: ["my","sg"] ,
	  utilsScript: "../intl-tel-input/build/js/utils.js"
	});
}

export default intPhoneNumber;